// @generated by tools/docgen — do not edit.
// Source: docs/examples/list_types.md

import React from 'react';
import { ListTypesDemo } from './demo';
import {
  ExampleLayout,
  ExampleSection,
  ExampleSectionHeading,
  ExampleDescription,
  ExampleClientBadge,
} from '../../components/ExampleLayout';
import { SourceFile } from '../../components/SourceFile';

export function ListTypesPage() {
  return (
    <ExampleLayout title="Union and optional list elements" demo={<ListTypesDemo />}>
      <ExampleSection position="first">
        <ExampleDescription>
          This example shows the rest of rx[list[S]]'s type surface: list[int | str] mixes element types in one array, and list[int] | None distinguishes the field being unset (null) from being set to an empty list ([]) — two genuinely different states, on the wire and in the generated types.
        </ExampleDescription>
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-list-types-backend">
        <ExampleSectionHeading id="examples-list-types-backend">
          Backend
        </ExampleSectionHeading>
        <SourceFile path="list_types/channels.py" />
      </ExampleSection>
      <ExampleSection ariaLabelledBy="examples-list-types-frontend" position="last">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <ExampleSectionHeading id="examples-list-types-frontend">
            Frontend
          </ExampleSectionHeading>
          <ExampleClientBadge />
        </div>
        <SourceFile path="list_types/demo.tsx" />
      </ExampleSection>
    </ExampleLayout>
  );
}

export default ListTypesPage;
